import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Controller, get, useFormContext } from 'react-hook-form';
import { Textarea } from '@mantine/core';
import { cn } from '@monorepo/utils';
const ControlledTextarea = ({ name, readOnly, errorEnabled = true, withCharCount = false, maxCharCount = 10000, control: controlProp, ...props }) => {
    // Try to get form context, but handle SSR gracefully
    let ctx;
    try {
        ctx = useFormContext();
    }
    catch (e) {
        // Context not available (SSR or outside FormProvider)
        ctx = null;
    }
    const effectiveControl = ctx?.control ?? controlProp;
    if (!effectiveControl) {
        if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
            console.warn(`ControlledTextarea "${name}" must be used inside a <FormProvider>. Rendering uncontrolled fallback.`);
        }
        return _jsx(Textarea, { ...props, readOnly: readOnly });
    }
    const errors = ctx?.formState?.errors;
    const isLoading = ctx?.formState?.isLoading ?? false;
    const isSubmitting = ctx?.formState?.isSubmitting ?? false;
    return (_jsxs("div", { className: 'relative w-full', children: [_jsx(Controller, { name: name, control: effectiveControl, render: ({ field }) => (_jsxs(_Fragment, { children: [_jsx(Textarea, { id: props.id ?? name, name: field.name, value: field.value ?? '', onChange: field.onChange, onBlur: field.onBlur, ref: field.ref, ...props, "aria-invalid": !!get(errors, name), readOnly: readOnly || isLoading || isSubmitting, classNames: {
                                label: 'text-sm text-gray-800 mb-2',
                                input: cn('border border-gray-300 text-gray-900 text-sm placeholder:font-normal '),
                                ...props.classNames,
                            } }), withCharCount ? (_jsxs("div", { className: cn('mt-2 text-sm text-gray-900', props.className), children: [(field.value?.length ?? 0), " / ", maxCharCount, " Characters"] })) : null] })) }), errorEnabled && (_jsx("div", { className: cn('mt-1 text-xs text-red-500', props.className), children: get(errors, name)?.message }))] }));
};
export default ControlledTextarea;
